import React, { useEffect } from "react";
// import Footer from "../components/Footer";

// import Homes from "../containers/Home";
// import NewHeader from "../LandingPage/HeaderComponent/Header";
import GrowBizHero from "../LandingPage2/GrowbizHero";

import FAQ from "../components/FAQ/FAQ";
import Footer2 from "../components/Footer/Footer";
import HowItWorks from "../components/HowItWorks/HowItWorks";
// import IncomePlan from "../components/IncomePlan/IncomePlan";
import OurPortfolio from "../LandingPage2/OurPortfolio";
const Home2 = () => {
  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);
  return (
    <>
      <GrowBizHero />
      <OurPortfolio />
      <HowItWorks />
      {/* <IncomePlan /> */}
      <FAQ />
      <Footer2 />
    </>
  );
};

export default Home2;
